<template>
    <x-page title="Pertemuan">
        <template #header-actions>
            <x-create-button
                :url="`/admin/gatherings/create?group_id=${$route.query.group_id}`"
                :disabled="isLoading"
                v-if="canCreateGroupGatherings($route.query.group_id)"
            />
            <x-back-button
                :disabled="isLoading"
                :display-warning="false"
                :click-handler="handleBackButtonClick"
            />
        </template>

        <x-filter-box :readonly="true" :open="true">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Group">
                        <input
                            type="text"
                            class="form-control"
                            :value="group ? group.label : '-'"
                            disabled
                        />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table :headers="['#', 'Tanggal', '']" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link
                        :to="`/admin/gatherings/${resource.id}?group_id=${$route.query.group_id}`"
                        title="Klik untuk lihat detail"
                    >
                        {{ resource.date | date }}
                    </router-link>
                </td>
                <td>
                    <x-quick-edit-button
                        :url="`/admin/gatherings/${resource.id}/edit?group_id=${$route.query.group_id}`"
                        :disabled="isLoading"
                        v-if="canUpdateGroupGatherings($route.query.group_id)"
                    />
                    <x-quick-delete-button
                        @click="deleteResource(resource)"
                        :disabled="isLoading"
                        v-if="canDeleteGroupGatherings($route.query.group_id)"
                    />
                </td>
            </tr>
        </x-table>

        <x-pagination
            v-if="shouldRenderPagination"
            :pagination="meta"
            :query="filters"
        />
    </x-page>
</template>

<script>
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XBackButton from "../../components/XBackButton.vue";
import XCreateButton from "../../components/XCreateButton.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import {
    deletePrompt,
    groupIndexUrl,
    handleGeneralXhrError,
} from "../../helpers";
import FilterableMixin from "../../mixins/FilterableMixin";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";
import XPagination from "../../components/XPagination.vue";

let defaultFilters = {
    group_id: null,
};

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
        XBackButton,
        XPagination,
    },
    created() {
        defaultFilters.group_id = this.$route.query.group_id;
        this.preselectFilters(defaultFilters);
        this.handleFilter().catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            filters: { ...defaultFilters },
            group: null,
            isLoading: false,
            resources: [],
        };
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.date,
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios
                        .delete(`/api/gatherings/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: "success",
                                title: `Berhasil`,
                                text: `${resource.date} dihapus!`,
                            });
                            this.fetchResources();
                        });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get("/api/gatherings", {
                    params: route.query,
                })
                .then((response) => {
                    this.resources = response.data.data;
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleBackButtonClick(router) {
            router.push(groupIndexUrl());
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                    without_global_scopes: 1,
                }),
            });
        },
        resetFilter() {
            this.filters = { ...defaultFilters };
            this.handleFilter();
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
    watch: {
        "filters.group_id": {
            handler(id) {
                this.syncFilterToProperty(id, "group", `/api/groups/${id}`);
            },
            immediate: true,
        },
        group: {
            handler(resource) {
                this.syncPropertyToFilter(resource, "group_id");
            },
            deep: true,
        },
    },
};
</script>
